import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    this.element.addEventListener("invalid", this.#flagInvalidField, true);
  }

  disconnect() {
    this.element.removeEventListener("invalid", this.#flagInvalidField, true);
  }

  showTab(event) {
    this.activate(event.currentTarget.dataset.tabId);
  }

  activate(tabId) {
    if (!tabId) return;
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tabId === tabId;
      tab.classList.toggle("active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabId !== tabId;
    });
  }

  #revealedInvalidTab = false;

  // Server-side errors already open the right tab; this reveals a field failing
  // native validation, whose message can't show on a hidden tab.
  #flagInvalidField = (event) => {
    const tabId = event.target.closest("[data-tab-id]")?.dataset.tabId;
    if (!tabId) return;
    this.#tabFor(tabId)?.classList.add("has-errors");
    if (this.#revealedInvalidTab) return;
    this.#revealedInvalidTab = true;
    this.activate(tabId);
    queueMicrotask(() => (this.#revealedInvalidTab = false));
  };

  #tabFor(tabId) {
    return this.tabTargets.find((tab) => tab.dataset.tabId === tabId);
  }
}
